
  import { createApiClient } from 'Network/ApiClient';
  
  export const IcdPayerRulesAxiosInstance = createApiClient('relationdiagnoses/');


